import React, { useState } from 'react';

const IpadBenefits = () => {
  const [activeCategory, setActiveCategory] = useState('pendidikan');

  const benefitCategories = {
    pendidikan: {
      title: "Manfaat Pendidikan",
      icon: "fas fa-graduation-cap",
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-500",
      benefits: [
        {
          no: 1,
          title: "Akses ke E-book, Tafsir, Kitab Digital, dan Video Pembelajaran",
          description: "Santri dapat membuka materi pembelajaran seperti Al-Qur'an digital, tafsir, kitab hadits, dan modul pelajaran hanya lewat satu perangkat.",
          icon: "fas fa-book-open",
          impact: "Efisiensi akses materi 100%"
        },
        {
          no: 2,
          title: "Pembelajaran Interaktif melalui LMS",
          description: "Santri mengerjakan kuis, menyimak video, dan berdiskusi daring dengan guru melalui platform LMS resmi pondok.",
          icon: "fas fa-laptop-code",
          impact: "Interaktivitas pembelajaran meningkat"
        },
        {
          no: 3,
          title: "Catatan Belajar Lebih Terstruktur & Terintegrasi",
          description: "Santri menulis catatan digital, menambahkan gambar, audio, dan membuat mind map langsung dari iPad mereka.",
          icon: "fas fa-edit",
          impact: "Organisasi belajar lebih baik"
        },
        {
          no: 4,
          title: "Efisiensi Bawaan Alat Belajar",
          description: "Tidak perlu membawa banyak buku fisik; semua materi, tugas, dan jadwal pelajaran tersedia dalam iPad.",
          icon: "fas fa-weight-hanging",
          impact: "Beban fisik berkurang drastis"
        },
        {
          no: 5,
          title: "Kemandirian dalam Mengelola Tugas dan Waktu",
          description: "Kalender belajar, pengingat tugas, dan check-in harian tersedia di dalam sistem, membantu santri belajar mandiri.",
          icon: "fas fa-clock",
          impact: "Manajemen waktu lebih baik"
        },
        {
          no: 6,
          title: "Persiapan Menuju Dunia Digital Modern",
          description: "iPad melatih santri terbiasa menggunakan teknologi edukatif seperti yang digunakan di perkuliahan dan dunia kerja.",
          icon: "fas fa-rocket",
          impact: "Kesiapan masa depan"
        }
      ]
    },
    pengasuhan: {
      title: "Manfaat Pengasuhan",
      icon: "fas fa-home",
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-500",
      benefits: [
        {
          no: 7,
          title: "Orang Tua Dapat Memantau Aktivitas Harian Anak Secara Real-time",
          description: "Kehadiran sekolah, belajar malam, ibadah, makan, mandi, dan kebersihan terdata & langsung bisa dilihat wali santri via dashboard.",
          icon: "fas fa-eye",
          impact: "Transparansi 100% untuk wali"
        },
        {
          no: 8,
          title: "Laporan Sholat Wajib dan Sunnah Terdata Harian Real-time",
          description: "Santri yang hadir/tidak hadir sholat Subuh, Zuhur, hingga Tahajjud dan Dhuha dicatat otomatis dan bisa dilihat wali.",
          icon: "fas fa-pray",
          impact: "Monitoring ibadah otomatis"
        },
        {
          no: 9,
          title: "Laporan Keterlambatan atau Ketidakhadiran Ibadah/Kegiatan",
          description: "Sistem mencatat keterlambatan ke masjid, tidak hadir belajar malam, telat ke makan, dan lainnya secara otomatis & objektif.",
          icon: "fas fa-exclamation-triangle",
          impact: "Kedisiplinan terukur objektif"
        },
        {
          no: 10,
          title: "Penilaian Adab, Kebersihan, dan Kedisiplinan Digital",
          description: "Nilai sikap, kebersihan kamar, kerapihan, dan interaksi sosial santri dinilai musyrif dan langsung masuk sistem pengasuhan digital.",
          icon: "fas fa-star",
          impact: "Penilaian karakter sistematis"
        },
        {
          no: 11,
          title: "Musyrif Dapat Memantau dan Merespon Cepat via iPad",
          description: "Musyrif melihat data sholat, kehadiran, dan kondisi siswa dari iPad masing-masing untuk mengambil tindakan pembinaan yang tepat.",
          icon: "fas fa-tachometer-alt",
          impact: "Respon pembinaan lebih cepat"
        },
        {
          no: 12,
          title: "Sistem Perizinan 3 Arah Otomatis (Wali Santri → Manajemen → Musyrif & Guru → Santri)",
          description: "Wali Santri mengajukan izin dari rumah, manajemen & musyrif/guru menyetujui dari iPad, lalu hasil izin masuk ke iPad santri & notifikasi ke wali santri.",
          icon: "fas fa-exchange-alt",
          impact: "Proses perizinan efisien"
        },
        {
          no: 13,
          title: "Informasi Kesehatan Santri Masuk Cepat ke Wali",
          description: "Jika anak sakit, keluhan dan penanganannya dicatat perawat lalu masuk sistem → bisa langsung dilihat oleh orang tua melalui LMS.",
          icon: "fas fa-heartbeat",
          impact: "Komunikasi kesehatan real-time"
        }
      ]
    },
    umum: {
      title: "Manfaat Umum & Sistem",
      icon: "fas fa-cog",
      color: "from-purple-500 to-purple-600",
      bgColor: "bg-purple-50",
      borderColor: "border-purple-500",
      benefits: [
        {
          no: 14,
          title: "Sistem MDM: iPad Terkunci & Dikontrol oleh Pondok",
          description: "Pondok membatasi akses aplikasi, internet, dan waktu penggunaan. Tidak bisa dipakai untuk media sosial, hiburan, atau game.",
          icon: "fas fa-shield-alt",
          impact: "Kontrol penggunaan 100%"
        },
        {
          no: 15,
          title: "Akademik dan Pengasuhan Terintegrasi dalam Satu Sistem Digital",
          description: "Guru dan musyrif sama-sama menggunakan iPad untuk mencatat nilai, ibadah, adab, dan laporan yang langsung bisa dilihat wali santri.",
          icon: "fas fa-link",
          impact: "Integrasi data menyeluruh"
        }
      ]
    }
  };

  const keyFeatures = [
    {
      title: "Real-time Monitoring",
      description: "Pemantauan aktivitas santri 24/7",
      icon: "fas fa-clock",
      color: "text-blue-600",
      bgColor: "bg-blue-100"
    },
    {
      title: "Sistem MDM Terkontrol",
      description: "Kontrol penuh penggunaan iPad",
      icon: "fas fa-shield-alt",
      color: "text-green-600",
      bgColor: "bg-green-100"
    },
    {
      title: "Integrasi Menyeluruh",
      description: "Akademik & pengasuhan dalam satu sistem",
      icon: "fas fa-link",
      color: "text-purple-600",
      bgColor: "bg-purple-100"
    },
    {
      title: "Transparansi Penuh",
      description: "Wali santri dapat memantau semua aktivitas",
      icon: "fas fa-eye",
      color: "text-orange-600",
      bgColor: "bg-orange-100"
    }
  ];

  const comparisonData = {
    before: [
      "Komunikasi terbatas dengan wali santri",
      "Laporan manual dan tidak real-time",
      "Sulit memantau aktivitas ibadah santri",
      "Buku fisik berat dan mudah rusak",
      "Penilaian subjektif dan tidak terstruktur",
      "Proses perizinan memakan waktu lama"
    ],
    after: [
      "Komunikasi real-time via dashboard digital",
      "Laporan otomatis dan instant",
      "Monitoring ibadah otomatis 24/7",
      "Semua materi dalam satu perangkat iPad",
      "Penilaian objektif dan terstruktur",
      "Perizinan digital 3 arah otomatis"
    ]
  };

  return (
    <div className="min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mb-6">
            <i className="fas fa-tablet-alt text-white text-3xl"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Manfaat Penggunaan iPad
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transformasi digital yang memberikan manfaat nyata untuk pendidikan, pengasuhan, dan sistem pembelajaran di Al Wafi Islamic Boarding School
          </p>
        </div>

        {/* Key Features Overview */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Fitur Utama Sistem iPad</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {keyFeatures.map((feature, index) => (
              <div key={index} className={`${feature.bgColor} rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2`}>
                <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-current ${feature.color}`}>
                  <i className={`${feature.icon} ${feature.color} text-2xl`}></i>
                </div>
                <h3 className={`text-lg font-bold ${feature.color} mb-2`}>{feature.title}</h3>
                <p className="text-gray-700 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center mb-12">
          {Object.entries(benefitCategories).map(([key, category]) => (
            <button
              key={key}
              onClick={() => setActiveCategory(key)}
              className={`mx-2 mb-4 px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center space-x-2 ${
                activeCategory === key
                  ? `bg-gradient-to-r ${category.color} text-white shadow-lg transform scale-105`
                  : 'bg-white text-gray-600 hover:bg-gray-50 shadow-md hover:shadow-lg'
              }`}
            >
              <i className={category.icon}></i>
              <span>{category.title}</span>
              <span className="bg-white bg-opacity-20 px-2 py-1 rounded-full text-xs">
                {category.benefits.length}
              </span>
            </button>
          ))}
        </div>

        {/* Benefits Detail */}
        <section className="mb-16">
          <div className={`${benefitCategories[activeCategory].bgColor} rounded-2xl p-8 mb-8`}>
            <div className="flex items-center justify-center mb-6">
              <div className={`w-16 h-16 bg-gradient-to-r ${benefitCategories[activeCategory].color} rounded-full flex items-center justify-center mr-4`}>
                <i className={`${benefitCategories[activeCategory].icon} text-white text-2xl`}></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-800">{benefitCategories[activeCategory].title}</h2>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {benefitCategories[activeCategory].benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden">
                <div className={`h-2 bg-gradient-to-r ${benefitCategories[activeCategory].color}`}></div>
                <div className="p-6">
                  <div className="flex items-start space-x-4 mb-4">
                    <div className={`w-12 h-12 bg-gradient-to-r ${benefitCategories[activeCategory].color} rounded-lg flex items-center justify-center flex-shrink-0`}>
                      <span className="text-white font-bold">{benefit.no}</span>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-gray-800 mb-2 leading-tight">{benefit.title}</h3>
                      <div className={`w-8 h-8 bg-gradient-to-r ${benefitCategories[activeCategory].color} rounded-lg flex items-center justify-center mb-3`}>
                        <i className={`${benefit.icon} text-white text-sm`}></i>
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 leading-relaxed">{benefit.description}</p>
                  <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gradient-to-r ${benefitCategories[activeCategory].color} text-white`}>
                    <i className="fas fa-check-circle mr-2"></i>
                    {benefit.impact}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Before vs After Comparison */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Perbandingan: Sebelum vs Sesudah iPad</h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Before */}
            <div className="bg-red-50 rounded-xl p-8 border-l-4 border-red-500">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mr-4">
                  <i className="fas fa-times text-white text-lg"></i>
                </div>
                <h3 className="text-2xl font-bold text-red-700">Sebelum Menggunakan iPad</h3>
              </div>
              <div className="space-y-4">
                {comparisonData.before.map((item, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <i className="fas fa-minus-circle text-red-500 mt-1 flex-shrink-0"></i>
                    <span className="text-red-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* After */}
            <div className="bg-green-50 rounded-xl p-8 border-l-4 border-green-500">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mr-4">
                  <i className="fas fa-check text-white text-lg"></i>
                </div>
                <h3 className="text-2xl font-bold text-green-700">Sesudah Menggunakan iPad</h3>
              </div>
              <div className="space-y-4">
                {comparisonData.after.map((item, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <i className="fas fa-check-circle text-green-500 mt-1 flex-shrink-0"></i>
                    <span className="text-green-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Statistics */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold text-center mb-8">Statistik Manfaat iPad</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">15</div>
                <div className="text-blue-100">Total Manfaat</div>
                <div className="text-sm text-blue-200">Kategori Lengkap</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">24/7</div>
                <div className="text-blue-100">Real-time</div>
                <div className="text-sm text-blue-200">Monitoring Aktif</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-blue-100">Terkontrol</div>
                <div className="text-sm text-blue-200">Sistem MDM</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold mb-2">3</div>
                <div className="text-blue-100">Kategori</div>
                <div className="text-sm text-blue-200">Pendidikan, Pengasuhan, Umum</div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mb-6">
              <i className="fas fa-tablet-alt text-white text-2xl"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Siap Merasakan Manfaat iPad?</h2>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Bergabunglah dengan transformasi digital Al Wafi dan rasakan sendiri 15 manfaat luar biasa penggunaan iPad dalam pendidikan Islam modern
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-info-circle mr-2"></i>
                Pelajari Lebih Lanjut
              </button>
              <button className="border-2 border-blue-500 text-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-500 hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                <i className="fas fa-phone mr-2"></i>
                Hubungi Kami
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default IpadBenefits;
